import { render, staticRenderFns } from "./UsersViewSharedCollections.vue?vue&type=template&id=3c65e8f9&"
import script from "./UsersViewSharedCollections.vue?vue&type=script&lang=js&"
export * from "./UsersViewSharedCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports